import React, { useEffect, useState, useMemo } from "react";

import Announcement from "./Announcement";
import HomeLeftInner from "./HomeLeftInner";
import HomeRightInner from "./HomeRightInner";
import "./modal.css";

const Home = () => {
  const [isModalOpen, setIsModalOpen] = useState(false); // Initially open

  const closeModal = () => {
    setIsModalOpen(false);
  };

  //  Show this announcement until Oct 13, 2014 only
  const [showAnnouncement, setShowAnnouncement] = useState(true);
  // Memoize the target date to avoid unnecessary recalculations
  const targetDate = useMemo(() => new Date("2025-06-20"), []); // Stop rendering component after this date

  useEffect(() => {
    const today = new Date();
    if (today > targetDate) {
      setShowAnnouncement(false);
    }

    const timer = setTimeout(() => {
      setIsModalOpen(false);
    }, 120000); // 2 minutes in milliseconds
    return () => clearTimeout(timer);
  }, [targetDate]);

  return (
    <div>
      <div className="announcement">
        {showAnnouncement && (
          <Announcement isOpen={isModalOpen} onClose={closeModal} />
        )}
      </div>
      <div className="main rediet-flex-direction">
        <div>
          <HomeLeftInner />
        </div>
        <div>
          <HomeRightInner />
        </div>
      </div>
    </div>
  );
};

export default Home;
